export default {
  placesAndDirections: {
    isochrones: 'Izochrony',
    place: 'místo',
    notRouteFound: 'Nebylo možné najít trasu spojující místa s vybraným profilem.',
    notRouteFoundWithFilters: 'Nebylo možné najít trasu spojující místa s vybraným profilem a filtry.',
    noPlaceFound: 'Nebylo nalezeno žádné místo se zadaným obsahem',
    routeReady: 'Trasa připravena',
    useLocation: 'GPS',
    addPlaceInput: 'Přidat místo',
    clearRoute: 'Vymazat trasu',
    reverseRoute: 'Obráceně',
    orderByClosestPlaces: 'Objednávejte podle míst blíže k vaší poloze',
    calculatingRoute: 'Výpočet trasy...',
    yourLocation: 'Vaše poloha',
    expandAltitudeChart: 'Rozbalit tabulku',
    errorRenderingContentUploaded: 'Chyba při vykreslování nahraného obsahu. Zkontrolujte formát a obsah souboru',
    roundTrip: 'Zpáteční cesta',
    notPossibleToCalculateRoute: 'Trasu nebylo možné vypočítat pomocí jednoho z vybraných míst.',
    apiError: {
      2000: 'Nelze analyzovat požadavek JSON',
      2001: 'Chybí požadovaný parametr',
      2002: 'Chybný formát parametru',
      2003: 'Parametry trasy překračují jeden nebo více limitů. Nezapomeňte, že některé vyhýbací parametry mají limity, například délka trasy a plocha vyhýbacího polygonu, která nesmí překročit 20000 km².',
      2004: 'Parametry trasy překračují jeden nebo více limitů. Nezapomeňte, že přibližná vzdálenost trasy nesmí být větší než 6000 km. Při použití určitých možností trasy nebo vyhýbacích možností nesmí být přibližná vzdálenost trasy větší než 150 km.',
      2006: 'Nelze analyzovat požadavek na obsluhu exportu',
      2007: 'Nepodporovaný formát exportu',
      2008: 'Prázdný prvek',
      2009: 'Nelze najít vhodnou trasu pro zadaná místa a kritéria. Možná, že zadaný profil není v této oblasti/regionu s použitými filtry podporován.',
      2010: 'Nebylo možné najít vhodný bod, který je součástí trasy. Možná jeden z vybraných bodů není směrovatelný nebo vybraný profil není v této oblasti podporován.',
      2011: 'Při použití možnosti alternativních tras není možné definovat zastávky na trase.',
      2012: 'Byl zadán neplatný parametr. Zkontrolujte, zda je adresa URL správná',
      2099: 'Nelze vypočítat trasu spojující vybraná místa'
    },
    genericErrorMsg: 'Nebylo možné vypočítat trasu',
    reorder: 'Přeskupit',
    timeoutError: 'Žádost trvala příliš dlouho a byla přerušena. Zkuste kratší vzdálenosti.'
  }
}
